// to auto generate an api from a swagger file:
// > npx @rtk-query/codegen-openapi openapi-config.ts
// > AVIYA::::: npm run update-api

import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { REACT_APP_SERVER_DOMAIN } from "../../base-env";

// Enhanced base query with comprehensive debugging
const baseQueryWithDebug = fetchBaseQuery({
    baseUrl: REACT_APP_SERVER_DOMAIN,
    credentials: "include",
    prepareHeaders(headers) {
      // headers.set("Access-Control-Allow-Credentials", " true");
      return headers;
    },
});

// Wrapper function to add API debugging
const baseQueryWithLogging = async (args: any, api: any, extraOptions: any) => {
  const startTime = performance.now();
  
  // Log API request
  console.group("🌐 API Call Debug");
  console.log("📤 Request:", {
    url: args.url,
    method: args.method || 'GET',
    body: args.body,
    timestamp: new Date().toISOString()
  });

  const result = await baseQueryWithDebug(args, api, extraOptions);
  
  const endTime = performance.now();
  const duration = endTime - startTime;

  // Log API response
  if (result.error) {
    console.error("❌ API Error:", {
      url: args.url,
      status: result.error.status,
      error: result.error,
      duration: `${duration.toFixed(2)}ms`
    });

    // Enhanced error logging for learning minutes debugging
    if (result.error.status === 400) {
      console.error("❌ BAD REQUEST (400): Backend validation failed");
      console.log("🔍 Common causes for learning minutes issues:");
      console.log("- Invalid time data (start >= end)");
      console.log("- Session already completed/closed");
      console.log("- Unit already completed");
      console.log("- Study duration > 8 hours");
      console.log("- Missing required fields");
    } else if (result.error.status === 404) {
      console.error("❌ NOT FOUND (404): Resource not found");
      console.log("🔍 Check if the feature/lesson/exercise ID exists");
    } else if (result.error.status === 500) {
      console.error("❌ SERVER ERROR (500): Backend processing failed");
      console.log("🔍 Check backend logs for learning minutes calculation errors");
    }
  } else {
    console.log("✅ API Success:", {
      url: args.url,
      status: 200,
      dataType: result.data ? typeof result.data : 'no data',
      hasLearningMinutes: result.data && typeof result.data === 'object' && 'learningMinutes' in result.data,
      duration: `${duration.toFixed(2)}ms`
    });

    // Log learning minutes data when present
    if (result.data && typeof result.data === 'object' && result.data !== null) {
      if ('learningMinutes' in result.data) {
        console.log("📊 Learning Minutes Found:", (result.data as any).learningMinutes);
      }
      if ('stats' in result.data && (result.data as any).stats && typeof (result.data as any).stats === 'object' && (result.data as any).stats !== null && 'learningMinutes' in (result.data as any).stats) {
        console.log("📊 Stats Learning Minutes Found:", (result.data as any).stats.learningMinutes);
      }
    }
  }

  console.groupEnd();
  return result;
};

export const baseApi = createApi({
  baseQuery: baseQueryWithLogging,
  endpoints: () => ({}),
});
